import Questionnaire from './Questionnaire';
import Collection from './ImmutableCollection';

export default class Questionnaires extends Collection(Questionnaire)<Questionnaire> {
}
